// safari < 15
import 'core-js/proposals/relative-indexing-method';

// Create Element.remove() function if not exist
if (!Element.prototype.remove) {
  Element.prototype.remove = function () {
    if (this.parentNode) {
      this.parentNode.removeChild(this);
    }
  };
}

/**
 * Ionic:
 * Prevents Angular change detection from
 * running with certain Web Component callbacks
 */
(window as any).__Zone_disable_customElements = true;
